module.exports = __webpack_public_path__ + "static/img/zhihuikeyan.9d1e08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhihuikeyan.jpg
// module id = qLEx
// module chunks = 20